<!-- Compact trigger shown inline in the host form -->
<div class="tr-trigger">
  <span class="tr-trigger-ico">
    <i class="fas fa-globe"></i>
  </span>
  <div class="tr-trigger-text">
    <div class="tr-trigger-title">{{ 'PREFERENCES.TRANSLATIONS_MULTI_LANGUAGE' | translate }}</div>
    <div class="tr-trigger-sub" *ngIf="languages.length === 0">
      {{ 'PREFERENCES.TRANSLATIONS_NONE_CONFIGURED' | translate }}
    </div>
    <div class="tr-trigger-sub" *ngIf="languages.length > 0">
      {{ 'PREFERENCES.TRANSLATIONS_CONFIGURED_SUMMARY'
        | translate: { filled: translatedLanguageCount, total: languages.length } }}
    </div>
    <div class="tr-trigger-chips" *ngIf="languages.length > 0">
      <span
        class="tr-tchip"
        *ngFor="let code of languages; trackBy: trackByLang"
        [class.done]="isLanguageDone(code)"
        [title]="langMeta(code).name"
      >
        <app-flag [code]="code" [size]="15" [title]="langMeta(code).name"></app-flag>
        {{ langMeta(code).name }}
        <span class="tr-tchip-ck" *ngIf="isLanguageDone(code)"><i class="fas fa-check"></i></span>
        <span class="tr-tchip-dot" *ngIf="!isLanguageDone(code)"></span>
      </span>
    </div>
  </div>
  <button type="button" class="btn tr-trigger-btn" (click)="open()">
    <i class="fas fa-globe"></i>
    {{ 'PREFERENCES.TRANSLATIONS_MANAGE' | translate }}
  </button>
</div>

<!-- Matrix modal -->
<app-modal
  #modal
  [title]="'PREFERENCES.TRANSLATIONS_MANAGE'"
  size="large"
  [closeOnOverlayClick]="true"
  [closeOnEscape]="true"
  [showCloseButton]="true"
  (closer)="isOpen = false"
>
  <div class="tr-modal">
    <div class="tg-toolbar">
      <span class="tg-toolbar-note">
        {{ 'PREFERENCES.TRANSLATIONS_CELLS_FILLED'
          | translate: { done: filledCells, total: totalCells } }}
      </span>
      <span class="tg-toolbar-spacer"></span>
      <button
        type="button"
        class="btn btn-ai"
        (click)="autoTranslate()"
        [disabled]="aiBusy || languages.length === 0 || missingCount === 0"
      >
        <i class="fas" [ngClass]="aiBusy ? 'fa-spinner fa-spin' : 'fa-magic'"></i>
        <span *ngIf="aiBusy">{{ 'PREFERENCES.TRANSLATIONS_TRANSLATING' | translate }}</span>
        <span *ngIf="!aiBusy && missingCount === 0">
          {{ 'PREFERENCES.TRANSLATIONS_ALL_TRANSLATED' | translate }}
        </span>
        <span *ngIf="!aiBusy && missingCount > 0">
          {{ 'PREFERENCES.TRANSLATIONS_AUTO_TRANSLATE' | translate: { count: missingCount } }}
        </span>
      </button>
    </div>

    <!-- Empty state: no configured languages -->
    <div class="tg-empty" *ngIf="languages.length === 0">
      <i class="fas fa-globe"></i>
      <div>{{ 'PREFERENCES.TRANSLATIONS_NONE_FOR_PAGES' | translate }}</div>
      <a class="btn btn-slate" routerLink="/preference-translations" (click)="close()">
        <i class="fas fa-globe"></i>
        {{ 'PREFERENCES.TRANSLATIONS_OPEN_SETTINGS' | translate }}
      </a>
    </div>

    <!-- Matrix grid -->
    <div class="tg-wrap" *ngIf="languages.length > 0">
      <div class="tg-scroll">
        <div class="tg-grid">
          <div class="tg-head">
            <div class="tg-h">{{ 'PREFERENCES.TRANSLATIONS_LANGUAGE' | translate }}</div>
            <div class="tg-h">{{ 'PREFERENCES.TRANSLATIONS_LABEL' | translate }}</div>
            <div class="tg-h">{{ 'PREFERENCES.TRANSLATIONS_DESCRIPTION' | translate }}</div>
          </div>

          <!-- English base row (read-only) -->
          <div class="tg-row tg-baserow">
            <div class="tg-c tg-c-lang">
              <app-flag code="en" [size]="20" title="English"></app-flag>
              <span class="tg-lang-name">{{ baseLanguage.name }}</span>
              <span class="tg-base-pill">{{ 'PREFERENCES.TRANSLATIONS_BASE' | translate }}</span>
            </div>
            <div class="tg-c tg-c-base">
              <span *ngIf="baseLabel">{{ baseLabel }}</span>
              <span class="tg-base-empty" *ngIf="!baseLabel">—</span>
            </div>
            <div class="tg-c tg-c-base">
              <span *ngIf="hasDescription">{{ baseDescription }}</span>
              <span class="tg-base-empty" *ngIf="!hasDescription">—</span>
            </div>
          </div>

          <!-- One row per configured language -->
          <div class="tg-row" *ngFor="let code of languages; trackBy: trackByLang">
            <div class="tg-c tg-c-lang">
              <app-flag [code]="code" [size]="20" [title]="langMeta(code).name"></app-flag>
              <span class="tg-lang-name">{{ langMeta(code).name }}</span>
              <span class="tg-lang-native">{{ langMeta(code).native }}</span>
            </div>
            <div class="tg-c tg-c-input" [class.missing]="isLabelMissing(code)">
              <input
                class="input tg-input"
                [dir]="isRtl(code) ? 'rtl' : 'ltr'"
                [placeholder]="('PREFERENCES.TRANSLATIONS_LABEL' | translate) + ' · ' + langMeta(code).name"
                [ngModel]="translations[code]?.label || ''"
                (ngModelChange)="setCell(code, 'label', $event)"
              />
            </div>
            <div class="tg-c tg-c-input" [class.missing]="isDescriptionMissing(code)">
              <input
                class="input tg-input"
                [dir]="isRtl(code) ? 'rtl' : 'ltr'"
                [placeholder]="hasDescription
                  ? ('PREFERENCES.TRANSLATIONS_DESCRIPTION' | translate) + ' · ' + langMeta(code).name
                  : ('PREFERENCES.TRANSLATIONS_DESCRIPTION' | translate)"
                [ngModel]="translations[code]?.description || ''"
                (ngModelChange)="setCell(code, 'description', $event)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tr-modal-foot">
      <button type="button" class="btn btn-link" (click)="close()">
        {{ 'GENERIC.CLOSE' | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="close()">
        {{ 'GENERIC.DONE' | translate }}
      </button>
    </div>
  </div>
</app-modal>
